export enum StartDateDefaultType {
    ThreeDaysBeforeToday = 'ThreeDaysBeforeToday',
    ThisWeekMonday = 'ThisWeekMonday',
    Today = 'Today',
    FirstDayNotPublished = 'FirstDayNotPublished',
}
